import { useSEO } from "@/hooks/use-seo";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Link } from "wouter";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  useSEO({
    title: "Stránka nenalezena – 404 | HrajBonus",
    description: "Hledaná stránka nebyla nalezena. Vraťte se na hlavní stránku HrajBonus a najděte nejlepší online kasina.",
    url: "https://hrajbonus.com/404",
    robots: "noindex, follow",
  });

  return (
    <div className="min-h-screen bg-[#f6f8fc]" style={{ fontFamily: "Poppins, sans-serif" }}>
      <Header />
      <main className="flex-1 flex items-center justify-center py-24 px-4">
        <div className="text-center max-w-lg mx-auto">
          <div className="text-8xl font-black text-[#003da5] mb-4">404</div>
          <h1 className="text-3xl font-black text-gray-900 mb-3">Stránka nebyla nalezena</h1>
          <h2 className="text-lg font-semibold text-gray-500 mb-8">Hledaná stránka neexistuje nebo byla přesunuta.</h2>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link href="/">
              <a className="inline-flex items-center gap-2 bg-[#003da5] text-white font-bold px-6 py-3 rounded-xl hover:bg-[#002d7c] transition-colors">
                <Home className="w-4 h-4" />
                Zpět na hlavní stránku
              </a>
            </Link>
            <Link href="/kasina">
              <a className="inline-flex items-center gap-2 border-2 border-[#003da5] text-[#003da5] font-bold px-6 py-3 rounded-xl hover:bg-[#003da5] hover:text-white transition-colors">
                <ArrowLeft className="w-4 h-4" />
                Přehled kasin
              </a>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
